import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { store, persistor } from './store/store'
import { RouteGenerator } from './app/router/RouteGenerator'
import ErrorBoundary from './app/components/ui/ErrorBoundary'
import LoadingState from './app/components/ui/LoadingState'
import './index.css'

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <ErrorBoundary 
            title="Application Error"
            message="Something went wrong with the application. Please try again."
            showDetails={process.env.NODE_ENV !== 'production'}
        >
            <Suspense fallback={<LoadingState fullScreen message="Loading application..." />}>
                <Provider store={store}>
                    <PersistGate loading={<LoadingState fullScreen message="Loading application state..." />} persistor={persistor}>
                        <RouterProvider router={RouteGenerator} />
                    </PersistGate>
                </Provider>
            </Suspense>
        </ErrorBoundary>
    </StrictMode>
)
